import { log } from 'log';
import uuid from 'uuid-random';
import React, { useEffect, useRef } from 'react';
import { compose, path } from 'js/utils/ramda.util';
import { Loader } from 'js/components/common/Loader';
import { useSelector, useDispatch } from 'react-redux';
import { SPORTSBOOK_REDUCER } from 'js/store/constants';
import { withComponent } from 'js/components/hocs/withComponent';
import { componentService } from 'js/services/component.service';
import { useComponentMethods, useComponentConfig, useComponentProps, useComponentTranslations } from 'js/hooks/component';

import * as actions from './store/actions';

export const SportsbookWidgetBare = () => {
    const dispatch = useDispatch();
    const regionId = useRef(uuid());
    const config = useComponentConfig();
    const { widgetname } = useComponentProps();
    const translate = useComponentTranslations();
    const { showComponentError } = useComponentMethods();
    const isAppInitError = useSelector(path([SPORTSBOOK_REDUCER, 'isAppInitError']));
    const isAppInitialized = useSelector(path([SPORTSBOOK_REDUCER, 'isAppInitialized']));
    const isIntegrationScriptError = useSelector(path([SPORTSBOOK_REDUCER, 'isIntegrationScriptError']));

    useEffect(() => {
        if (isIntegrationScriptError || isAppInitError) {
            showComponentError(translate('error.unavailable'));
        }
    }, [isAppInitError, isIntegrationScriptError, showComponentError, translate]);

    useEffect(() => {
        dispatch(actions.startIntegration());
    }, [dispatch]);

    useEffect(() => {
        if (isAppInitialized) {
            const id = regionId.current;

            try {
                window.Sportsbook.mountWidget?.(widgetname, id, config);
            } catch (e) {
                log('log', '[SPORTSBOOK | Portal] Mount sportsbook widget error', e);
            }

            return () => {
                try {
                    window.Sportsbook.unmountWidget?.(id);
                } catch (e) {
                    log('log', '[SPORTSBOOK | Portal] Unmount sportsbook widget error', e);
                }
            };
        }
    }, [regionId, widgetname, config, isAppInitialized]);

    return (
        <div id={regionId.current}><Loader /></div>
    );
};

export const SportsbookWidget = compose(
    withComponent({
        tkPrefix: 'playtech.mobile.system.sportsbook.'
    })
)(SportsbookWidgetBare);

componentService.registerWebContentComponents({ SportsbookWidget });
